import React from "react";
import { SvgIcon } from "@material-ui/core";


export default function PlayIcon(): JSX.Element {
    return (
        <SvgIcon viewBox="0 0 79 79">
            <path
                fillRule="evenodd"
                d="M39.5 79C61.3152 79 79 61.3152 79 39.5C79 17.6848 61.3152 0 39.5 0C17.6848 0 0
                17.6848 0 39.5C0 61.3152 17.6848 79 39.5 79ZM59.5 40L29.5 19V61L59.5 40Z"
                fill="white"
            />
        </SvgIcon>
    );
}
